import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  StockCountFilterRootParamList,
  StockCountsRootParamList,
} from "../../../../types";
import {
  Button,
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import {
  FilterListRenderContextType,
  GenericFilterListScreen,
  useGenericFilterListScreen,
} from "../../../../components/GenericFilterListScreen";
import { useTranslation } from "../../../../utilities/i18n";
import { useListFilterContext } from "../../../../utilities/list-filter/use-list-filter-context";
import { StockCountFilterValues } from "../../types";
import { StockCountFilterScreen } from "../StockCountFilterScreen";

export interface StockCountFilterRootScreenProps
  extends StackScreenProps<
    StockCountsRootParamList,
    "StockCountFilterRootScreen"
  > {}

export const StockCountFilterRootScreen =
  ({}: StockCountFilterRootScreenProps) => {
    const listScreenContext = useGenericFilterListScreen();
    const filterContext = useListFilterContext<StockCountFilterValues>();
    const { t } = useTranslation("stock_counts");

    const RootNavigator =
      createStackHeaderNavigator<StockCountFilterRootParamList>();

    return (
      <FilterListRenderContextType.Provider value={listScreenContext}>
        <RootNavigator.Navigator
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <RootNavigator.Group
            screenOptions={{
              headerShown: true,
              title: "",
              headerLeft: () => <ModalCloseButton type="Close" />,
              headerRight(props) {
                return (
                  <Button
                    label={t("common:clear_filters")}
                    isAction
                    disabled={
                      filterContext.filterState.activeFiltersCount === 0
                    }
                    onPress={filterContext.clearAll}
                    size="compact"
                  />
                );
              },
            }}
          >
            <RootNavigator.Screen
              name="StockCountFilterScreen"
              component={StockCountFilterScreen}
            />
          </RootNavigator.Group>
          <RootNavigator.Group
            screenOptions={{
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
          >
            <RootNavigator.Screen
              name="GenericFilterListScreen"
              component={GenericFilterListScreen}
            />
          </RootNavigator.Group>
        </RootNavigator.Navigator>
      </FilterListRenderContextType.Provider>
    );
  };
